// extracted by mini-css-extract-plugin
module.exports = {"inner-wrapper":"_9e1425b4d3--inner-wrapper--Fyady","footnote":"_9e1425b4d3--footnote--poo8z"};